import { useQueryIncentiveCampaignDetail } from './useCampaignDetail';
import { useQueryIncentiveCampaignAccumulated } from './useIncentiveCampaignAccumulatedAmount';
import { useQueryIncentiveCampaignOptin, useMutationIncentiveCampaignOptin } from './useOptin';
import { useQueryIncentiveCampaignRanking } from './useRanking';
import { useQueryIncentiveCampaignRankingResults } from './useRankingResults';
import { useMutationIncentiveCampaignSSO } from './useSSO';

const useIncentiveCampaign = {
  optin: {
    useQuery: useQueryIncentiveCampaignOptin,
    useMutation: useMutationIncentiveCampaignOptin,
  },
  ranking: {
    useQuery: useQueryIncentiveCampaignRanking,
    useResults: useQueryIncentiveCampaignRankingResults,
  },
  accumulated: {
    useQuery: useQueryIncentiveCampaignAccumulated,
  },
  sso: {
    useMutation: useMutationIncentiveCampaignSSO,
  },
  campaign: {
    useQuery: useQueryIncentiveCampaignDetail,
  },
};

export { useIncentiveCampaign };
